import { render, staticRenderFns } from "./InventoryReports.html?vue&type=template&id=136e5862&external"
import script from "./InventoryReports.js?vue&type=script&lang=js&external"
export * from "./InventoryReports.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports